module.exports = __webpack_public_path__ + "static/media/nestje4.519f0016.jpg";